module.exports = __webpack_public_path__ + "static/assets/7d50459b34124a3d180747e9158acf7c.svg";